import { getPromotion } from "@api/getPromotions";
import { ModalCardPromotion } from "@modals/modalpromotions/ModalCardPromotion";
import { useTokenStore } from "@store/TokenStore";
import { ZustandContext } from "@store/modalStore";
import { usePolicyStore } from "@store/policyStore";
import { useContext, useEffect, useState } from "react";
import { checarProduct } from "@utils/product";

export default function useCoupon(){
  const [visible, setVisible] = useState(false);
  const [isData, setIsData] = useState(false);
  const { show, hide } = useContext(ZustandContext);
  const { policy, addPolicyInfo } = usePolicyStore();
  const { token } = useTokenStore();

  useEffect(() => {
    getPromotion(token)
      .then(() => setIsData(true))
    getDay();
  }, []);

  useEffect(() => {
    if (visible && isData) {
      saveDateVisibleModal();
      if (policy.acceptCoupon === '') {
        show(ModalCardPromotion, { onClose: hide });
      }
    } else {
      hide();
    }
  }, [visible, isData]);

  const saveDateVisibleModal = () => {
    if (policy.endDateTime === '') {
      let startDate = new Date();
      let day = 60 * 60 * 24 * 1000;
      let endDate = new Date(startDate.getTime() + day);
      addPolicyInfo({ ...policy, endDateTime: new Date(endDate).toString() });
    }
  };
  
  const viewCoupon = () => {
    setVisible(true);
  };
  
  const closeCoupon = () => {
    setVisible(false);
  };

  function isActivated(hoursActive: any) {
    const dates = hoursActive.map((dateString: string) => {
      const [hour, minute] = dateString.split(':');
      let date = new Date();
      date.setHours(Number(hour), Number(minute), 0, 0);
      return date;
    });

    let isActive = false;
    const now = new Date();

    for (let i = 0; i < dates.length; i = i + 2) {
      isActive =
        isActive ||
        (now.valueOf() >= dates[i].valueOf() &&
          now.valueOf() <= dates[i + 1].valueOf());
    }
    return isActive;
  }

  const weekdayAction = () => {
    setInterval(function () {
        checkButton();
    }, 2000);

    function checkButton() {
      let hoursActive = ['08:00', '23:00'];
      if (isActivated(hoursActive) && !checarProduct()) {
        viewCoupon();
      } else {
        closeCoupon();
      }
    }
  };

  const weekendAction = () => {
    setInterval(function () {
      checkButton();
    }, 2000);
    
    function checkButton() {
      let hoursActive = ['07:59', '15:01'];
      if (!isActivated(hoursActive) && !checarProduct()) {
        viewCoupon();
      } else {
        closeCoupon();
      }
    }
  };

  const getDay = () => {
    let date = new Date();
    let day = date.getDay();
    let ans = day === 6 || day === 0;
    if (ans) {
        weekendAction();
    } else {
        weekdayAction();
    }
  };
}